import React from 'react'
import { ChatbotStepActionData, talkToAgentActionData } from '../../../../models/flowBuilderTypes'
import formStyles from './../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss'
import globalStyles from "../../../../assets/styles/global.module.scss";
import { Grid, Typography } from '@mui/material';
import { getCustomVariableConditionText, getTalkToAgentDescriptionText } from '../flowBuilderConstants';
import { useFlowBuilderStore } from '../../../../store/flowBuilderStore';

interface TalkToAgentNodeProps {
    id: string, 
    data: ChatbotStepActionData<talkToAgentActionData>
} 

const TalkToAgentNode: React.FC<TalkToAgentNodeProps> = (props) => {
    
    const { id, data } = props;
    const customVariableList = useFlowBuilderStore((state) => state.customVariableList)

    return (
        <>
            <Grid item>
                <Grid container className={`${globalStyles.displayFlexStyle} ${globalStyles.flexColumn}`}>
                    <Grid item>
                        <Typography className={formStyles.dataSavedTextStyle}>
                            Assign Agent
                        </Typography>
                    </Grid>

                    <Grid item>
                        <Typography className={formStyles.dataSavedValueStyle}>
                            {getTalkToAgentDescriptionText(customVariableList, data?.action_data?.condition_group, data?.action_data?.assignment_strategy_type)?.descriptionTextInNode}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default TalkToAgentNode
